import { useMemo } from 'react'

import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import type { DealBadgeFlags } from '@/helpers/deals/resolveDealBadge'
import { FeatureFlags } from '@/helpers/featureFlags'

/**
 * The flags `resolveDealBadge` reads, in one place so callers never name them
 * individually. Memoized so the set is a stable dependency.
 */
export const useDealBadgeFlags = (): DealBadgeFlags => {
  const alp = useFlag(FeatureFlags.ENABLE_FMV_DEAL_BADGE_ALP)
  const storefront = useFlag(FeatureFlags.ENABLE_SELLER_STOREFRONT_DEALS_BADGE)
  const lowBidder = useFlag(FeatureFlags.ENABLE_LOW_BIDDER_DEAL_BADGE_ALP)

  return useMemo(
    () => ({ alp, storefront, lowBidder }),
    [alp, storefront, lowBidder]
  )
}
